import { useEffect, useRef } from 'react';

interface MessageLogProps {
  messages: string[];
  className?: string;
}

export default function MessageLog({ messages, className }: MessageLogProps) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (el) {
      el.scrollTop = el.scrollHeight;
    }
  }, [messages]);
  return (
    <div
      ref={ref}
      className={`overflow-y-auto rounded border border-black bg-white p-2 text-xs text-black ${className ?? ''}`}
    >
      {messages.map((m, i) => (
        <div key={i}>{m}</div>
      ))}
    </div>
  );
}
